export const PROPOSAL_SECTIONS = {
  site_protection: {
    title: "Site Protection & Preparation",
    description: [
      "Cover and protect all windows, fencing, landscaping, and other surrounding property to prevent damage before starting the project.",
    ],
  },
  removal_inspection: {
    title: "Removal & Inspection",
    description: [
      "Remove all layers of shingles and felt down to the plywood deck.",
      "Inspect the existing plywood decking for any signs of damage or deterioration.",
      "Replace up to five sheets of plywood at no additional cost; additional plywood replacement is charged at $110 per sheet.",
    ],
  },
  cleanup_final: {
    title: "Cleanup & Final Inspection",
    description: [
      "Perform a thorough cleanup of all job-related debris from the property.",
      "Conduct a final walkthrough and inspection to ensure quality workmanship and customer satisfaction.",
    ],
  },
};

export const WARRANTY_CONTENT = {
  workmanship: {
    title: "Workmanship Warranty",
    description: "Safeway Home Improvements provides a 10-year workmanship warranty on all roofing services outlined in this estimate.",
  },
  manufacturer: {
    title: "Manufacturer Warranty (Silver Pledge)",
    benefits: [
      "50-Year Non-Prorated Coverage: GAF Timberline UHDZ® shingles are covered for up to 50 years against manufacturing defects (non-prorated).",
      "Workmanship Coverage Backed by GAF: The Silver Pledge includes up to 10 years of workmanship coverage backed directly by GAF, in addition to Safeway's own workmanship warranty.",
      "Full System Protection: Coverage applies only when GAF roofing components are installed as a complete system, ensuring long-term performance.",
    ],
  },
};
